'use client';
import { forwardRef } from 'react';
import { Box } from '@wanteddev/wds-engine';
import { flexBoxStyle } from './style.mjs';
import { jsx } from 'react/jsx-runtime';

var FlexBox = forwardRef(
  ({
    as,
    flexDirection,
    flexWrap,
    justifyContent,
    alignItems,
    alignContent,
    order,
    flex,
    flexGrow,
    flexShrink,
    flexBasis,
    alignSelf,
    gap,
    xs,
    sm,
    md,
    lg,
    xl,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx(
      Box,
      {
        as: as || "div",
        ref,
        ...props,
        sx: [
          flexBoxStyle({
            flexDirection,
            flexWrap,
            justifyContent,
            alignItems,
            alignContent,
            order,
            flex,
            flexGrow,
            flexShrink,
            flexBasis,
            alignSelf,
            gap,
            xs,
            sm,
            md,
            lg,
            xl
          }),
          props.sx
        ]
      }
    );
  }
);
FlexBox.displayName = "FlexBox";
var flex_box_default = FlexBox;

export { flex_box_default as default };
